import moment from 'moment';
import { QUOTE_STATE } from './enums';
import { isNumber } from './math';

// La cotización vence a los N días de su fecha inicial; la fecha final ya no se ingresa.
export const getQuoteExpiryDate = (startDate, validityDays) =>
  startDate && isNumber(validityDays) ? moment(startDate).add(Number(validityDays), 'days') : null;

export const formatValidity = (validityDays) =>
  `${validityDays} ${Number(validityDays) === 1 ? 'día' : 'días'}`;

// No se usa actualmente.
export const getMPercPpto = (lines, currKardex) => {
  const totalKardex = lines.reduce((acc, elem) => acc + elem.kardex, 0);
  return (currKardex / totalKardex) * 100;
};

export const getPrice = (projectedCost, mgPerc) => {
  const decimalPerc = mgPerc / 100;
  return projectedCost / (1 - decimalPerc);
};

export const getMarginPerUnit = (kardex, projectedCost, mgPerc) =>
  getPrice(projectedCost, mgPerc) - kardex;

// export const getTotalMargin = (zcot, mgPerc, volumeKg) =>
//   (getPrice(zcot, mgPerc) - zcot) * volumeKg;
export const getTotalMargin = (projectedCost, mgPerc, volumeKg) =>
  getPrice(projectedCost, mgPerc) * (mgPerc / 100) * volumeKg;

export const getTotalSale = (projectedCost, mgPerc, volumeKg) =>
  getPrice(projectedCost, mgPerc) * volumeKg;

export const getQuoteStateLabel = (number) => {
  const labels = {
    [QUOTE_STATE.PENDING]: 'Pendiente',
    [QUOTE_STATE.AWARDED]: 'Adjudicado',
    [QUOTE_STATE.LOST]: 'Perdido',
  };
  return labels[number];
};
